
export const removeLastCharacter = (date: string) =>
  date.length === 2 || date.length === 5 ? date.slice(0, -1) : date;

export const addTrailingDot = (date: string) => (date.length === 2 || date.length === 5 ? date + "." : date);

export const sanitizeDate = (date: string, pressedKey: string) => {
  if (pressedKey === "deleteContentBackward" || pressedKey === "deleteContentForward") {
    return removeLastCharacter(date);
  }

  let value = date;

  switch (date.length) {
    case 1:
      return !/^[0-3]$/.test(date) ? date.slice(0, -1) : date;
    case 2:
      if (!/^[0-3][0-9]$/.test(date)) value = date.slice(0, -1);
      if (value.length === 2) {
        if (parseInt(value) > 31) return value.slice(0, -1);
        else value = addTrailingDot(value);
      }
      break;
    case 4:
      return !/^[0-3][0-9]\.[0-1]$/.test(date) ? date.slice(0, -1) : date;
    case 5:
      if (!/^[0-3][0-9]\.[0-1][0-9]$/.test(date)) value = date.slice(0, -1);
      if (value.length === 5) {
        if (parseInt(value.split(".")[1]) > 12) value = value.slice(0, -1);
        else value = addTrailingDot(value);
      }
      break;
    case 7:
      return !/^[0-3][0-9]\.[0-1][0-9]\.[1-2]$/.test(date) ? date.slice(0, -1) : date;
    case 8:
      if (parseInt(value[value.length - 2]) === 2) {
        return !/^[0-3][0-9]\.[0-1][0-9]\.[1-2][0]$/.test(date) ? date.slice(0, -1) : date;
      } else {
        return !/^[0-3][0-9]\.[0-1][0-9]\.[1-2][9]$/.test(date) ? date.slice(0, -1) : date;
      }
    default:
      return !/^[0-3][0-9]\.[0-1][0-9]\.[0-9]{0,4}$/.test(date) ? date.slice(0, -1) : date;
  }

  return value;
};


export const toFormattedDate = (isoDate?: string) => {
  if (!isoDate) return "";
  const parts = isoDate.split("-");
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
};

export const toIsoDate = (formattedDate: string) => {
  if (!formattedDate) return null;
  const parts = formattedDate.split(".");
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};
